// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__YrghE","detailsBorder":"styles_detailsBorder__18YpU"};